import * as React from "react";
import Button from "../button";
import List from "./components/list";
import Spinner from "../spinner";
import Summary from "./components/summary";
import styles from "./reviews.module.scss";
import StampedContext from "../../StampedContext";

const Reviews = () => {
  const {
    data,
    currentPage,
    error,
    loading,
    loadMoreReviews,
    pageAmount,
    reviews
  } = React.useContext(StampedContext);

  return !error ? (
    <div className={styles.reviews}>
      <h2>What Our Beautiful Users Are Saying</h2>

      <Summary data={data} />

      <List reviews={reviews} />

      {loading && <Spinner className={styles.spinner} />}
      {currentPage < pageAmount && !loading && (
        <Button className={styles.loadMoreButton} onClick={loadMoreReviews}>
          Show me more reviews
        </Button>
      )}
    </div>
  ) : null;
};

export default Reviews;
